module.exports = __webpack_public_path__ + "static/img/loginBack.75c6bb68.jpg";